const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/profilio"],
    exact: true,
    component: "Profilio",
  },
  {
    path: [ "/reviews"],
    exact: true,
    component: "Reviews",
  },
];

export default routes;
